import types from "./types";

const initialState = {
  activeCustomFilter: null,
  activeCustomFilterState: null,
  customFilters: []
}

const userReducer = (state = initialState, action) => {
  switch (action.type)
  {
    case types.SET_ACTIVE_CUSTOM_FILTER:
      return {
        ...state,
        activeCustomFilter: action.payload.activeCustomFilter,
        activeCustomFilterState: action.payload.activeCustomFilterState
      }
    case types.SET_CUSTOM_FILTERS:
      return {
        ...state,
       customFilters: action.payload.customFilters
      }

    default:
      return state;
  }
}

export default userReducer;
